import { useQueryClient } from "@tanstack/react-query";

import { rqClient } from "@/shared/api/instance";
import { useSession } from "@/shared/model/session";

export function useUser() {
  const queryClient = useQueryClient();
  const { isAuthenticated, login, logout } = useSession();

  const query = rqClient.useQuery(
    "get",
    "/api/v1/user",
    {},
    {
      enabled: isAuthenticated,
    },
  );

  const isStoreOwner = query.data?.role === "seller";

  return {
    user: query.data ?? null,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    isAuthenticated,
    isStoreOwner,
    refetch: query.refetch,
    clearUser: () =>
      queryClient.invalidateQueries({ queryKey: ["get", "/api/v1/user"] }),
    login,
    logout,
  };
}
